<template>
  <el-card class="add-page-container" :body-style="{display:'flex'}">
    <div class="main" :style="{height:mainHeight}">
      <el-button type="text" icon="el-icon-back" @click="back">返回静态页面列表</el-button>
      <span class="static-pages-tips">
        <el-button class="iconfont icon-history" v-show="pageId" @click="showMoreHistory" type="text">历史记录</el-button>
        <el-tooltip class="item" effect="dark" placement="left-start">
          <div slot="content">
            <p>输入需知：</p>
            <p><span class="color-red">*</span>1. icon：如需替换icon，请先将原上传icon删除。</p>
            <p><span class="color-red">*</span>2. 正文：复制图片是默认是引入图片的地址（一般显示不出来），
              需要重新复制单个图片。</p>
            <p><span class="color-red">*</span>3. 预览：预览同时将保存为草稿。</p>
            <p><span class="color-red">*</span>4. 草稿：已发布的页面保存草稿不会生效，将在后续版本中完善。</p>
            <p><span class="color-red">*</span>5. 标题：默认格式h1、左对齐。</p>
            <p><span class="color-red">*</span>6. 更多设置按钮：可以对静态页面进行更多的设置，如：设置页面权限、默认标题等。</p>
            <p><span class="color-red">*</span>7. 静态页面操作权限：
              <br /><br /> （1）所有人可编辑（writen）：所有用户可以编辑/删除当前的静态页面。
              <br /><br /> （2）仅个人查看/编辑（onlyMe）：仅当前用户查看或编辑静态页面，其他用户不可见。
              <br /><br /> （3）其他人只读/不可编辑（readOnly）：其他用户只能查看静态页面，无法编辑/删除。
            </p>
          </div>
          <el-button type="text">
            <i class="el-icon-question tips-icon"></i>
          </el-button>
        </el-tooltip>
      </span>
      <div class="main-icon">
        <template>
          <el-checkbox v-model="customIcon">自定义页面icon</el-checkbox>
        </template>
        <div class="upload">
          <el-upload class="static-icon-upload" action="" :limit="1" :multiple="false" :http-request="uploadIcon" :on-remove="handleRemove" :file-list="fileList">
            <el-button size="small" type="primary" :disabled="!customIcon">点击上传</el-button>
          </el-upload>
        </div>
        <el-button style="margin:0 20px" @click="isExpendSize" type="text">{{isExpend?'收起':'更多设置'}}<i :class="isExpend?'el-icon-arrow-up':'el-icon-arrow-down'" style="margin-left:8px"></i></el-button>
      </div>
      <div v-show="isExpend" class="expend-condition-form">
        <el-checkbox class="expend-condition-item" v-model="useDefaultTitle">使用默认标题</el-checkbox>
        <el-checkbox class="expend-condition-item" v-model="useDefaultPadding">使用默认边距</el-checkbox>
        <el-checkbox class="expend-condition-item" v-model="useBackTopButton">使用返回顶部按钮</el-checkbox>
        <el-select v-if="uid===userInfo.id||uid==''||userInfo.isAdmin" class="expend-condition-item" v-model="powers" placeholder="请选择文章权限">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input @blur="checkUrlValid" style="width:360px" v-model="defaultStylesUrl" placeholder="请输入默认样式文件地址，仅支持css文件"></el-input>
      </div>
      <div class="main-input">
        <el-input placeholder="请输入标题，必填" v-model="title" clearable>
        </el-input>
      </div>
      <div id="div1">
        <vue-tinymce v-model="editorHtml" :setting="setting" />
      </div>
      <div class="text" v-if="pageId">
        <span>最后更新于：{{updateTime}}</span>
      </div>
      <div class="main-btn">
        <el-button size="small" type="primary" plain @click="saveHtml(3)">
          <span class="iconfont icon-yulan5 btn-icon"></span> 预览
        </el-button>
        <el-button size="small" type="warning" plain @click="saveHtml(0)">
          <span class="iconfont icon-caogao1 btn-icon"></span>
          保存为草稿
        </el-button>
        <el-button size="small" type="success" plain @click="saveHtml(1)">
          <span class="iconfont icon-shengcheng btn-icon"></span> 生成文档页面
        </el-button>
      </div>
    </div>
    <div v-if="pageId&&showHistory" class="history-container">
      <div class="title">全部记录</div>
      <div class="history-item" v-for="item in historyList" :key="item.id" :class="{active:item.id===pageCid}" @click="clickHistoryItem(item)">
        <div class="date">{{dateFormat('YYYY-MM-DD HH:mm:ss', item.createTime)}}</div>
        <div class="user">{{`${item.user&&item.user.realName||'未知用户'}（${item.user&&item.user.userCode}）`}}</div>
        <el-tag class="type" size="mini" type="info" v-show="latestCid===item.id">当前版本</el-tag>
      </div>
    </div>
  </el-card>
</template>

<script>
import { pageApi, xpsApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import dayjs from 'dayjs';
import { getExt } from '@/common/utils/ext.js';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      locations: process.env.NODE_ENV === 'development' ? window.location.origin + '/api' : window.location.origin,
      editorHtml: '',
      title: '',
      height: 700,
      customIcon: false,
      fileList: [],
      iconUrl: '',
      iconName: '',
      pageId: '',
      pageCid: '',
      uid: '',
      updateTime: '',
      mainHeight: 650,
      isExpend: false,
      useDefaultTitle: true,
      useDefaultPadding: true,
      useBackTopButton: true,
      defaultStylesUrl: '',
      oldDefaultStylesUrl: '',
      powers: 'writen',
      options: [{
        value: 'writen',
        label: '所有人可编辑'
      }, {
        value: 'onlyMe',
        label: '仅个人查看/编辑'
      },
      {
        value: 'readOnly',
        label: '其他人只读/不可编辑'
      },
      {
        value: 'innerNet',
        label: '只允许内网访问'
      },
      ],
      setting: {
        menubar: true,
        toolbar: "undo redo | fullscreen preview code | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media hr emoticons codesample insertdatetime table| fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | ltr rtl |superscript subscript charmap | removeformat | print imagetools paste  | wordcount searchreplace tabfocus save autosave autolink | help",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "link code image media table lists fullscreen quickbars preview print imagetools help wordcount tabfocus save paste autosave autolink  searchreplace hr charmap emoticons codesample directionality insertdatetime",
        language: 'zh_CN', //本地化设置
        language_url: "https://front-xps-cdn.xsyx.xyz/custom/tinymce/langs/zh_CN.js",
        height: 700,
        toolbar_sticky: true,
        autosave_ask_before_unload: false,
        automatic_uploads: true,
        paste_data_images: true,
        images_upload_url: '/api/uploadCos',
        // 保存内容回调函数
        save_onsavecallback: function () {
          window.saveHtml(1);
        },
        // 自定义上传
        images_upload_handler: function (blobInfo, succFun, failFun) {
          window.uploadImage(blobInfo, succFun, failFun);
        },
        // 粘贴触发
        // paste_preprocess: function (plugin, args) {}
      },
      olderEditorHtml: '',
      showHistory: false,
      historyList: [],
      latestCid: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    editorHtml (val) {
      this.$store.commit('config/SET_IS_SAVE', this.olderEditorHtml === val);
    }
  },
  async beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize);
  },
  mounted () {
    this.pageId = this.$route.query.id;
    if (this.pageId) this.getEditData();
    // 挂载到window对象上
    window.editorVue = this;
    window.saveHtml = this.saveHtml;
    window.uploadImage = this.uploadImage;
    // 设置editor响应式
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },
  methods: {
    // 选中历史记录item，触发事件
    clickHistoryItem (data) {
      if (this.pageCid !== data.id) {
        this.fileList = [];
        this.getEditData(data.id);
      }
    },
    // 显示静态页面历史记录
    showMoreHistory () {
      this.showHistory = !this.showHistory;
      this.getStaticpageHistory();
    },
    async getStaticpageHistory () {
      if (this.showHistory) {
        showLoading();
        const res = await pageApi.getStaticpageHistory({ id: this.pageId })
        if (res.code === 200) {
          this.$nextTick(() => {
            this.historyList = res.data;
          })
        }
        hideLoading();
      }
    },
    // 检验url地址有效性
    checkUrlValid () {
      // 如果输入了css地址
      if (this.defaultStylesUrl && this.defaultStylesUrl !== this.oldDefaultStylesUrl) {
        // 校验地址是否有效
        if (/(http|https):\/\/([\w.]+\/?)\S*.css$/.test(this.defaultStylesUrl)) {
          return true;
        } else {
          this.$message.warning('无效地址：' + this.defaultStylesUrl)
          return false;
        }
      }
    },
    // 展开/收缩 富文本盒子大小配置
    isExpendSize () {
      this.isExpend = !this.isExpend
      document.querySelector('.tox-tinymce').style.height = this.isExpend ? `${this.height - 42}px` : `${this.height}px`;
    },
    // 窗口响应式配置 Editor 高度
    onWindowResize () {
      this.height = document.body.offsetHeight - 317;
      const dom = document.querySelector('.tox-tinymce');
      if (dom) {
        dom.style.height = this.isExpend ? `${this.height - 42}px` : `${this.height}px`;
      } else {
        setTimeout(() => {
          this.onWindowResize()
        }, 100);
      }

    },
    // 图片上传
    async uploadImage (blobInfo, succFun, failFun) {
      let file = blobInfo.blob();//转化为易于理解的file对象
      const form = new FormData();
      // 文件对象
      form.append("file_data", file);
      form.append("fileName", file.name);
      form.append("fileExt", file.name.substring(file.name.lastIndexOf('.') + 1));
      form.append("source", 'static-html');
      let res = null;
      try {
        res = await xpsApi.openApi(form);
      } catch (e) {
        failFun(e)
        console.log('uploadRequest error', e);
        that.$message.error('上传图片出错或文件过大！');
        return null;
      }
      // 上传图片，返回结果，将图片插入到编辑器中
      succFun(res.cdnPath)
    },
    // 获取编辑数据
    async getEditData (cid) {
      showLoading();
      let param = {
        id: this.pageId
      };
      if (cid) Object.assign(param, { cid });
      let _res = await pageApi.getStaticpageById(param);
      this.updateTime = this.dateFormat('YYYY-MM-DD HH:mm:ss', _res.list.updateTime)
      this.pageCid = _res.list.cid;
      if (!cid) {
        this.latestCid = _res.list.cid;
      }
      this.title = _res.list.title;
      this.useDefaultTitle = _res.list.useDefaultTitle;
      this.useDefaultPadding = _res.list.useDefaultPadding;
      this.useBackTopButton = _res.list.useBackTopButton;
      this.defaultStylesUrl = _res.list.defaultStylesUrl;
      this.oldDefaultStylesUrl = this.defaultStylesUrl;
      this.powers = _res.list.power || 'writen';
      this.uid = _res.list.uid
      if (_res.list.iconUrl) {
        this.iconUrl = _res.list.iconUrl;
        this.iconName = _res.list.iconName || 'default.png'
        this.fileList.push({ name: this.iconName, url: this.iconUrl })
        this.customIcon = true;
      }
      this.olderEditorHtml = _res.list.content;
      this.editorHtml = _res.list.content;
      hideLoading();
    },
    // 跳转生产文档页面 index==1修改静态页面 index!=1 创建静态页面
    async pageJump (param, index) {
      let _res = {};
      if (index == 1) {
        _res = await pageApi.updateStaticpage(param);
      } else {
        _res = await pageApi.createStaticpage(param);
      }
      if (_res.code != 200) {
        this.$message.error(_res.message);
      } else {
        this.pageId = _res.id;
        this.pageCid = _res.cid;
        this.latestCid = _res.cid;
        this.$confirm(`是否立即前往页面地址：${this.locations}/p/${_res.id}`, '页面发布成功！', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.open(`${this.locations}/p/${_res.id}`)
        })
      }
      this.getStaticpageHistory();
    },
    // 保存
    async saveHtml (status = 0) {
      const editorVue = window.editorVue || this;
      editorVue.olderEditorHtml = editorVue.editorHtml;
      editorVue.$store.commit('config/SET_IS_SAVE', true);
      //为空校验 
      if (editorVue.title == '') {
        editorVue.$message.warning('请输入标题！');
        return null;
      }
      if (editorVue.editorHtml === '') {
        editorVue.$message.warning('请输入正文！');
        return null;
      }
      if (editorVue.customIcon) {
        if (editorVue.iconUrl == null || editorVue.iconUrl == '') {
          editorVue.$message.warning('请上传icon！');
          return null;
        }
      }
      if (editorVue.defaultStylesUrl && !editorVue.checkUrlValid()) {
        return null;
      }
      // 表单参数
      let param = {
        title: editorVue.title.trim(),
        status: status == 3 ? 0 : status,
        content: editorVue.editorHtml,
        useDefaultTitle: editorVue.useDefaultTitle,
        useDefaultPadding: editorVue.useDefaultPadding,
        useBackTopButton: editorVue.useBackTopButton,
        defaultStylesUrl: editorVue.defaultStylesUrl ? editorVue.defaultStylesUrl.trim() : '',
        power: editorVue.powers,
      }
      if (editorVue.customIcon) {
        param.iconUrl = editorVue.iconUrl;
        param.iconName = editorVue.iconName
      }

      try {
        // if (  editorVue.pageId) {
        let _res = {};

        if (status == 0 || status == 3) {
          if (editorVue.pageId) {
            param.id = editorVue.pageId;
            _res = await pageApi.updateStaticpage(param);
          } else {
            _res = await pageApi.createStaticpage(param);
          }
          // console.log(_res)
          if (_res.code !== 200) {
            if (status === 0)
              editorVue.$message.error(_res.message);
          } else {
            editorVue.pageId = _res.id;
            editorVue.pageCid = _res.cid;
            editorVue.updateTime = editorVue.dateFormat('YYYY-MM-DD HH:mm:ss', _res.updateTime)
            if (status === 0) editorVue.$message.success('保存草稿成功！');
            editorVue.getStaticpageHistory();
          }
        } else if (status == 1) {
          let self = editorVue;
          editorVue.$confirm(`确认发布`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (self.pageId) {
              param.id = self.pageId;
              self.pageJump(param, 1);
            } else {
              self.pageJump(param, 0);
            }
          })
        }
        if (status == 3) {
          window.open(window.location.origin + '/api/staticpageApi/review?id=' + editorVue.pageCid)
        }

      } catch (e) {
        editorVue.$message.error('操作失败！');
      }
    },
    // icon上传
    async uploadIcon (params) {
      const form = new FormData();
      // 文件对象
      form.append("file_data", params.file);
      form.append("fileName", params.file.name);
      form.append("fileExt", getExt(params.file.name));
      form.append("source", 'static-html');
      try {
        let res = await xpsApi.openApi(form);
        this.iconUrl = res.cdnPath;
        this.iconName = res.localFileName
        this.$message.success('页面icon上传成功！')
      } catch (e) {
        console.log('uploadRequest error', e);
        that.$message.error('上传图片出错或文件过大！');
        return null;
      }
    },
    back () {
      this.$router.push({ path: '/staticPage' })
    },
    // 日期格式化
    dateFormat (fmt, date) {
      return dayjs(date).format(fmt);
    },
    // 预览
    preview () {
      this.saveHtml();
      let previewPage = this.$router.resolve({
        path: "/preview",
      });
      window.open(previewPage.href, '_blank')
    },
    handleRemove () {
      this.iconUrl = ''
      this.iconName = ''
      this.$message.info('页面icon已移除！')
    }
  },
  // 组件销毁时触发
  destroyed () {
    // 清除window窗口监听
    window.removeEventListener('resize', this.onWindowResize);
  },
}
</script>

<style lang="scss" scoped>
.add-page-container {
  position: relative;
  margin: 24px;
  border-radius: 16px !important;

  .static-pages-tips {
    display: flex;
    float: right;
    height: 65px;
    align-items: center;
    .tips-icon {
      color: #5862ab;
      font-size: 25px;
    }
  }
  .static-icon-upload {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-upload-list {
    display: inline-block;
    position: relative;
    left: 10px;
    .el-upload-list__item:first-child {
      margin-top: 0px;
    }
  }
  .main {
    width: calc(100vw - 130px);
    margin: -5px auto;
    .main-icon {
      .upload {
        display: inline-block;
        margin-left: 20px;
      }
    }
    .tip {
      padding: 8px 16px;
      background-color: #ecf8ff;
      border-radius: 4px;
      border-left: 5px solid #50bfff;
      margin: 0;
    }
    .main-right {
      width: 15%;
      float: left;
      color: #606266;
      font-size: 14px;
      padding: 0 10px;
    }
    .main-left {
      width: 85%;
      padding: 25px 0 0 0;
      float: right;
    }
    .main-input {
      margin: 10px 0;
    }
    .text {
      margin: 10px 0;
      float: left;
      color: #9d9fa3;
      font-size: 14px;
    }
    .main-btn {
      margin: 10px 0;
      float: right;
      .btn-icon {
        font-size: 14px;
      }
    }
  }
  .expend-condition-form {
    padding-top: 10px;
    .expend-condition-item {
      margin-right: 20px;
    }
  }
  .history-container {
    margin-left: 20px;
    padding: 0 10px;
    min-width: 260px;
    max-height: calc(100vh - 160px);
    overflow-y: auto;
    border-left: 1px solid #cccccc;
    .title {
      margin: 8px 24px;
      font-weight: 600;
    }
    .history-item {
      position: relative;
      margin-bottom: 5px;
      padding: 8px 24px;
      color: #262626;
      font-size: 14px;
      cursor: pointer;
      border-radius: 6px;
      &:hover {
        background-color: #f4f5f5;
      }
      &.active {
        background-color: #f4f5f5;
      }
      .type {
        position: absolute;
        right: 8px;
        top: 24px;
      }
    }
  }
}
</style>
